import {
  BirthControlRequestKey,
  EmergencyContraceptionKey,
  LastProtectIntercourse,
  MethodKey,
  SexualHealthKey,
  STITeleconsultationKey,
  STITestingKey,
  MenstrualHealthKey,
  BirthControlTeleconsultationKey,
  BirthControlRefillKey,
  HairLossTeleconsultationKey,
  AcneTeleconsultationKey,
  WeightLossKeys,
  MenopauseTeleconsultationKey,
  FertilityTestKeys,
  MenopausalProfileTestKeys,
  BoneDensityTestKeys,
  HotFlashesTreatmentKey,
  HPVTestKeys,
  HPVVaccinationKeys,
  PapSmearTestKeys,
  VaginalDrynessTreatmentKey,
  PCOSTestKeys,
  MammogramBreastUltrasoundTestKeys,
  ThyroidFunctionTestKeys,
  AmenorrhoeaTestKeys,
  PeriodControlMedicationKey,
} from '~/redux/questionnaires/types';
import {DropdownOptions, LabelValueString} from '~/types/general';

export const NO_DRUG_ALLERGIES = 'NO';
export const OTHER_BRAND = 'OTHER';
export const YES_OPTION = 'YES';
export const NO_OPTION = 'NO';
export const NONE_OF_THE_ABOVE_VALUE = 'NONE_OF_THE_ABOVE';

export const SPEAK_TO_CARE_TEAM_DEEPLINK =
  'https://easeapp.page.link/?link=https%3A%2F%2Feaseapp.page.link%2Ftoday%3FshouldDisplayZendesk%3Dtrue%26ibi%3Dorg.ease.EaseApp%26apn%3Dcom.easeapp';

export const TELEHEALTH_DEEPLINK =
  'https://easeapp.page.link/?link=https://easeapp.page.link/telehealth&ibi=org.ease.EaseApp&apn=com.easeapp';

export const EASE_LINK = 'http://ease-healthcare.com/';

export const SPEAK_TO_CARE_TEAM_LINK =
  'https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=easehealthcare.zendesk.com&settings=JTdCJTIyd2ViV2lkZ2V0JTIyJTNBJTdCJTIyY2hhdCUyMiUzQSU3QiUyMnRpdGxlJTIyJTNBbnVsbCUyQyUyMm1lbnVPcHRpb25zJTIyJTNBJTdCJTIyZW1haWxUcmFuc2NyaXB0JTIyJTNBdHJ1ZSU3RCUyQyUyMmRlcGFydG1lbnRzJTIyJTNBJTdCJTdEJTJDJTIycHJlY2hhdEZvcm0lMjIlM0ElN0IlMjJkZXBhcnRtZW50TGFiZWwlMjIlM0FudWxsJTJDJTIyZ3JlZXRpbmclMjIlM0FudWxsJTdEJTJDJTIyb2ZmbGluZUZvcm0lMjIlM0ElN0IlMjJncmVldGluZyUyMiUzQW51bGwlN0QlMkMlMjJjb25jaWVyZ2UlMjIlM0ElN0IlMjJhdmF0YXJQYXRoJTIyJTNBbnVsbCUyQyUyMm5hbWUlMjIlM0FudWxsJTJDJTIydGl0bGUlMjIlM0FudWxsJTdEJTdEJTJDJTIyY29sb3IlMjIlM0ElN0IlMjJhcnRpY2xlTGlua3MlMjIlM0ElMjIlMjIlMkMlMjJidXR0b24lMjIlM0ElMjIlMjIlMkMlMjJoZWFkZXIlMjIlM0ElMjIlMjIlMkMlMjJsYXVuY2hlciUyMiUzQSUyMiUyMiUyQyUyMmxhdW5jaGVyVGV4dCUyMiUzQSUyMiUyMiUyQyUyMnJlc3VsdExpc3RzJTIyJTNBJTIyJTIyJTJDJTIydGhlbWUlMjIlM0FudWxsJTdEJTdEJTdE&&locale=en-us&title=Web%20Widget%20Live%20Chat';

export const METHOD_KEYS: Record<MethodKey, MethodKey> = {
  EMERGENCY_CONTRACEPTION: 'EMERGENCY_CONTRACEPTION',
  SEXUAL_HEALTH: 'SEXUAL_HEALTH',
  STI_TELECONSULTATION: 'STI_TELECONSULTATION',
  BIRTH_CONTROL_REQUEST: 'BIRTH_CONTROL_REQUEST',
  STI_TESTING: 'STI_TESTING',
  MENSTRUAL_HEALTH: 'MENSTRUAL_HEALTH',
  BIRTH_CONTROL_TELECONSULTATION: 'BIRTH_CONTROL_TELECONSULTATION',
  BIRTH_CONTROL_REFILL: 'BIRTH_CONTROL_REFILL',
  PH_CHECKOUT: 'PH_CHECKOUT',
  HAIR_LOSS_TELECONSULTATION: 'HAIR_LOSS_TELECONSULTATION',
  ACNE_TELECONSULTATION: 'ACNE_TELECONSULTATION',
  WEIGHT_LOSS_PROGRAM: 'WEIGHT_LOSS_PROGRAM',
  MENOPAUSE_TELECONSULTATION: 'MENOPAUSE_TELECONSULTATION',
  FERTILITY_TEST: 'FERTILITY_TEST',
  MENOPAUSAL_PROFILE_TEST: 'MENOPAUSAL_PROFILE_TEST',
  BONE_DENSITY_TEST: 'BONE_DENSITY_TEST',
  HOT_FLASHES_TREATMENT: 'HOT_FLASHES_TREATMENT',
  HPV_TEST: 'HPV_TEST',
  HPV_VACCINATION: 'HPV_VACCINATION',
  PAP_SMEAR_TEST: 'PAP_SMEAR_TEST',
  VAGINAL_DRYNESS_TREATMENT: 'VAGINAL_DRYNESS_TREATMENT',
  PCOS_TEST: 'PCOS_TEST',
  MAMMOGRAM_BREAST_ULTRASOUND_TEST: 'MAMMOGRAM_BREAST_ULTRASOUND_TEST',
  THYROID_FUNCTION_TEST: 'THYROID_FUNCTION_TEST',
  AMENORRHOEA_TEST: 'AMENORRHOEA_TEST',
  PERIOD_CONTROL_MEDICATION: 'PERIOD_CONTROL_MEDICATION',
};

export const MENOPAUSE_TELECONSULTATION_KEYS: Record<MenopauseTeleconsultationKey, MenopauseTeleconsultationKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  SELECT_SYMPTOMS: 'SELECT_SYMPTOMS',
  DESCRIBE_CURRENT_SYMPTOMS: 'DESCRIBE_CURRENT_SYMPTOMS',
  HAVING_REGULAR_PERIODS: 'HAVING_REGULAR_PERIODS',
  CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING: 'CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING',
  UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS: 'UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS',
  UP_TO_DATE_BREAST_SCREENINGS: 'UP_TO_DATE_BREAST_SCREENINGS',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const VAGINAL_DRYNESS_TREATMENT_KEYS: Record<VaginalDrynessTreatmentKey, VaginalDrynessTreatmentKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  SELECT_SYMPTOMS: 'SELECT_SYMPTOMS',
  DESCRIBE_CURRENT_SYMPTOMS: 'DESCRIBE_CURRENT_SYMPTOMS',
  HAVING_REGULAR_PERIODS: 'HAVING_REGULAR_PERIODS',
  CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING: 'CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING',
  UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS: 'UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS',
  UP_TO_DATE_BREAST_SCREENINGS: 'UP_TO_DATE_BREAST_SCREENINGS',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const HOT_FLASHES_TREATMENT_KEYS: Record<HotFlashesTreatmentKey, HotFlashesTreatmentKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  SELECT_SYMPTOMS: 'SELECT_SYMPTOMS',
  DESCRIBE_CURRENT_SYMPTOMS: 'DESCRIBE_CURRENT_SYMPTOMS',
  HAVING_REGULAR_PERIODS: 'HAVING_REGULAR_PERIODS',
  CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING: 'CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING',
  UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS: 'UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS',
  UP_TO_DATE_BREAST_SCREENINGS: 'UP_TO_DATE_BREAST_SCREENINGS',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const EMERGENCY_CONTRACEPTION_KEYS: Record<EmergencyContraceptionKey, EmergencyContraceptionKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  EMERGENCY_CONTRACEPTION_USED: 'EMERGENCY_CONTRACEPTION_USED',
  LAST_UNPROTECTED_INTERCOURSE: 'LAST_UNPROTECTED_INTERCOURSE',
  PREFERRED_BRAND: 'PREFERRED_BRAND',
  PURCHASE_PREGNANCY_TEST: 'PURCHASE_PREGNANCY_TEST',
  LAST_PERIOD_AT: 'LAST_PERIOD_AT',
  HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH: 'HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  MEDICATION_BEING_TREATED: 'MEDICATION_BEING_TREATED',
  NEGATIVE_BIRTH_CONTROL: 'NEGATIVE_BIRTH_CONTROL',
  OTHER_MEDICAL_HISTORY: 'OTHER_MEDICAL_HISTORY',
};

export const SEXUAL_HEALTH_KEYS: Record<SexualHealthKey, SexualHealthKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  STATEMENT_BEST_APPLIES: 'STATEMENT_BEST_APPLIES',
  SELECT_SYMPTOMS: 'SELECT_SYMPTOMS',
  HOW_LONG_HAD_SYMPTOMS: 'HOW_LONG_HAD_SYMPTOMS',
  TAKEN_MEDICATION_OR_SIMILAR_CONDITION_BEFORE: 'TAKEN_MEDICATION_OR_SIMILAR_CONDITION_BEFORE',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const BIRTH_CONTROL_REQUEST_KEYS: Record<BirthControlRequestKey, BirthControlRequestKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  BRAND_USED: 'BRAND_USED',
  BRAND_USED_B: 'BRAND_USED_B',
  STATEMENT_BEST_APPLIES: 'STATEMENT_BEST_APPLIES',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH: 'HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH',
  DO_SMOKE: 'DO_SMOKE',
  HAS_SMOKED: 'HAS_SMOKED',
  MEDICATION_BEING_TREATED: 'MEDICATION_BEING_TREATED',
  OTHER_MEDICAL_HISTORY: 'OTHER_MEDICAL_HISTORY',
  CHOOSE_MEDICATION: 'CHOOSE_MEDICATION',
  CHOOSE_PRODUCT_PACKAGE: 'CHOOSE_PRODUCT_PACKAGE',
  LAST_BC_PURCHASE: 'LAST_BC_PURCHASE',
};

export const STI_TESTING_KEYS: Record<STITestingKey, STITestingKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  WHY_THINKING_STI_TEST: 'WHY_THINKING_STI_TEST',
  MORE_INFORMATION: 'MORE_INFORMATION',
  SAMPLE_COLLECTION_LOCATION: 'SAMPLE_COLLECTION_LOCATION',
  CHOOSE_MEDICATION: 'CHOOSE_MEDICATION',
};

export const WEIGHT_LOSS_KEYS: Record<WeightLossKeys, WeightLossKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  IMPORTANT_INFORMATION: 'IMPORTANT_INFORMATION',
  ABOUT_SAXENDA: 'ABOUT_SAXENDA',
  HOW_WEIGHT_LOSS_PROGRAM_WORKS: 'HOW_WEIGHT_LOSS_PROGRAM_WORKS',
  BMI_CALCULATOR: 'BMI_CALCULATOR',
  BMI_UNDERWEIGHT: 'BMI_UNDERWEIGHT',
  BMI_HEALTHY_BLOCK: 'BMI_HEALTHY_BLOCK',
  BMI_HEALTHY_NEXT: 'BMI_HEALTHY_NEXT',
  BMI_OVERWEIGHT: 'BMI_OVERWEIGHT',
  BMI_ALLERGIC: 'BMI_ALLERGIC',
  OBESITY_RELATED_CONDITIONS: 'OBESITY_RELATED_CONDITIONS',
  FOLLOWING_APPLY: 'FOLLOWING_APPLY',
  DESCRIBE_CURRENT_LIFESTYLE: 'DESCRIBE_CURRENT_LIFESTYLE',
  DESCRIBE_CURRENT_EATING_HABITS: 'DESCRIBE_CURRENT_EATING_HABITS',
  TAKE_WEIGHT_LOSS_MEDICATION_BEFORE: 'TAKE_WEIGHT_LOSS_MEDICATION_BEFORE',
  DID_MEDICATION_WORK: 'DID_MEDICATION_WORK',
  METABOLIC_ASSESSMENT: 'METABOLIC_ASSESSMENT',
  DOCTOR_ASSESSMENT: 'DOCTOR_ASSESSMENT',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const FERTILITY_TEST_KEYS: Record<FertilityTestKeys, FertilityTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  ON_BIRTH_CONTROL: 'ON_BIRTH_CONTROL',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const MENOPAUSAL_PROFILE_TEST_KEYS: Record<MenopausalProfileTestKeys, MenopausalProfileTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const BONE_DENSITY_TEST_KEYS: Record<BoneDensityTestKeys, BoneDensityTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const HPV_TEST_KEYS: Record<HPVTestKeys, HPVTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const PCOS_TEST_KEYS: Record<PCOSTestKeys, PCOSTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const THYROID_FUNCTION_TEST_KEYS: Record<ThyroidFunctionTestKeys, ThyroidFunctionTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const AMENORRHOEA_TEST_KEYS: Record<AmenorrhoeaTestKeys, AmenorrhoeaTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS: Record<
  MammogramBreastUltrasoundTestKeys,
  MammogramBreastUltrasoundTestKeys
> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const HPV_VACCINATION_KEYS: Record<HPVVaccinationKeys, HPVVaccinationKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const PAP_SMEAR_TEST_KEYS: Record<PapSmearTestKeys, PapSmearTestKeys> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  APPOINTMENT_PREFERENCES: 'APPOINTMENT_PREFERENCES',
  YOUR_TEST_PACKAGE: 'YOUR_TEST_PACKAGE',
};

export const STI_TELECONSULTATION_KEYS: Record<STITeleconsultationKey, STITeleconsultationKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  STATEMENT_BEST_APPLIES: 'STATEMENT_BEST_APPLIES',
  MORE_INFORMATION: 'MORE_INFORMATION',
};

export const MENSTRUAL_HEALTH_KEYS: Record<MenstrualHealthKey, MenstrualHealthKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  LAST_PERIOD_AT: 'LAST_PERIOD_AT',
  PERIODS_USUAL_LAST_FOR: 'PERIODS_USUAL_LAST_FOR',
  MENSTRUAL_CYCLE: 'MENSTRUAL_CYCLE',
  CHOOSE_ILLNESS: 'CHOOSE_ILLNESS',
  SELECT_SYMPTOMS: 'SELECT_SYMPTOMS',
  HOW_TO_DEAL: 'HOW_TO_DEAL',
};

export const BIRTH_CONTROL_TELECONSULTATION_KEYS: Record<
  BirthControlTeleconsultationKey,
  BirthControlTeleconsultationKey
> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  BRAND_USED: 'BRAND_USED',
  BRAND_USED_B: 'BRAND_USED_B',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH: 'HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH',
  DO_SMOKE: 'DO_SMOKE',
  HAS_SMOKED: 'HAS_SMOKED',
  MEDICATION_BEING_TREATED: 'MEDICATION_BEING_TREATED',
  OTHER_MEDICAL_HISTORY: 'OTHER_MEDICAL_HISTORY',
  LAST_BC_PURCHASE: 'LAST_BC_PURCHASE',
};

export const HAIR_LOSS_TELECONSULTATION_KEYS: Record<HairLossTeleconsultationKey, HairLossTeleconsultationKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  LOOKING_FOR_HELP: 'LOOKING_FOR_HELP',
  SELECT_SYMPTOMS: 'SELECT_SYMPTOMS',
  IMPORTANT_TREATING_HAIR_LOSS: 'IMPORTANT_TREATING_HAIR_LOSS',
  HAIR_LOSS_MEDICATION_OR_TREATMENT: 'HAIR_LOSS_MEDICATION_OR_TREATMENT',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const BIRTH_CONTROL_REFILL_KEYS: Record<BirthControlRefillKey, BirthControlRefillKey> = {
  PURCHASE_NOT_FOUND: 'PURCHASE_NOT_FOUND',
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  LAST_BC_PURCHASE: 'LAST_BC_PURCHASE',
  STATEMENT_BEST_APPLIES: 'STATEMENT_BEST_APPLIES',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH: 'HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH',
  DO_SMOKE: 'DO_SMOKE',
  HAS_SMOKED: 'HAS_SMOKED',
  OTHER_MEDICAL_HISTORY: 'OTHER_MEDICAL_HISTORY',
  CHOOSE_MEDICATION: 'CHOOSE_MEDICATION',
  CHOOSE_PRODUCT_PACKAGE: 'CHOOSE_PRODUCT_PACKAGE',
};

export const ACNE_TELECONSULTATION_KEYS: Record<AcneTeleconsultationKey, AcneTeleconsultationKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  SKINCARE_GOALS: 'SKINCARE_GOALS',
  SKIN_TYPE: 'SKIN_TYPE',
  DESCRIBE_SKIN_CONDITION: 'DESCRIBE_SKIN_CONDITION',
  PREGNANT_OR_BREASTFEEDING: 'PREGNANT_OR_BREASTFEEDING',
  HAVE_SIDE_EFFECTS_OR_ALLERGIC: 'HAVE_SIDE_EFFECTS_OR_ALLERGIC',
  ON_ACNE_OR_SKIN_TREATMENT: 'ON_ACNE_OR_SKIN_TREATMENT',
  OTHER_MEDICATIONS_OR_SUPPLEMENTS: 'OTHER_MEDICATIONS_OR_SUPPLEMENTS',
  OTHER_CONDITION_OR_MEDICAL_HISTORY: 'OTHER_CONDITION_OR_MEDICAL_HISTORY',
};

export const PERIOD_CONTROL_MEDICATION_KEYS: Record<PeriodControlMedicationKey, PeriodControlMedicationKey> = {
  START: 'START',
  PROFILE: 'PROFILE',
  INVALID: 'INVALID',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
  HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH: 'HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH',
  DO_SMOKE: 'DO_SMOKE',
  OTHER_MEDICATIONS_OR_SUPPLEMENTS: 'OTHER_MEDICATIONS_OR_SUPPLEMENTS',
  OTHER_MEDICAL_HISTORY: 'OTHER_MEDICAL_HISTORY',
};

export const LAST_PROTECT_INTERCOURSE: Record<LastProtectIntercourse, LabelValueString> = {
  PAST_12_HOURS: {
    label: 'in the past 12 hours',
    value: 'PAST_12_HOURS',
  },
  BT_12_48_HOURS: {
    label: 'between 12 to 48 hours ago',
    value: 'BT_12_48_HOURS',
  },
  BT_2_4_DAYS: {
    label: 'between 2 and 4 days ago',
    value: 'BT_2_4_DAYS',
  },
  M_4_DAYS: {
    label: 'more than 4 days ago',
    value: 'M_4_DAYS',
  },
  DID_NOT: {
    label: 'I didn’t. I just want to be prepared.',
    value: 'DID_NOT',
  },
};

export const SEX_VALUES = {
  female: 'Female',
  male: 'Male',
  nonBinary: 'Non-binary',
};

export const SEX_OPTIONS: DropdownOptions = [
  {
    label: 'Female',
    value: SEX_VALUES.female,
  },
  {
    label: 'Male',
    value: SEX_VALUES.male,
  },
  {label: 'Non-binary', value: SEX_VALUES.nonBinary},
];

export const PHOTO_ID_TYPE_VALUES = {
  NRIC: 'NRIC',
  passport: 'Passport',
};

export const PHOTO_ID_TYPE_OPTIONS: DropdownOptions = [
  {
    label: 'NRIC',
    value: PHOTO_ID_TYPE_VALUES.NRIC,
  },
  {
    label: 'Passport',
    value: PHOTO_ID_TYPE_VALUES.passport,
  },
];

export const PROGRESS_DATA = [
  {
    label: 'Evaluation',
    value: 1,
  },
  {
    label: 'Selection',
    value: 2,
  },
  {
    label: 'Checkout',
    value: 3,
  },
];

export const AT_HOME = 'AT_HOME';
export const BIRTH_CONTROL_PATCH = 'PATCH';
export const FREE_DELIVERY_KEY = 'free';
export const STANDARD_DELIVERY_KEY = 'standard';
export const PATCH_TOP_ICON = 'patch-top-icon';
export const BMI_30 = 30;
export const BMI_27 = 27;
export const BMI_25 = 25;
export const BMI_18_5 = 18.5;

export enum BlockScreenType {
  'UNDER_18_YEAR_OLD' = 'UNDER_18_YEAR_OLD',
  'BMI_UNDER_27' = 'BMI_UNDER_27',
  'BMI_UNDER_30_WITHOUT_OBESITY_CONDITION' = 'BMI_UNDER_30_WITHOUT_OBESITY_CONDITION',
  'UNSUITABLE_MEDICAL_HISTORY' = 'UNSUITABLE_MEDICAL_HISTORY',
}

export const mergeObjectWithKeys = (data: any, authUser: any) => {
  let newObj: any = {};
  for (let k in authUser) {
    newObj[k] = data[k] || authUser[k];
  }
  return newObj;
};

export const isPayloadWithErrorCode = (error: unknown): error is {errStatusCode: number} => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'errStatusCode' in error &&
    typeof (error as any).errStatusCode === 'number'
  );
};
